module.exports = __webpack_public_path__ + "img/apply-submit.04419146.png";